var ExtraPricing;

(function(){
    ExtraPricing = {

        formatForConsumption: function(){

        },
        getDateRangeInclusive: function(start, end){
            //end = moment(end).add(1, 'day');
            //if(moment(start).hour(0).minute(0).second(0).toString() !== moment(end).hour(0).minute(0).second(0).toString()){
            //    end = moment(end).add(1,'day');
            //}
            return moment.range(moment(start), moment(end));
        },
        getDateRangeExclusive: function(start, end){
            end = moment(end).subtract(1, 'days');
            return moment.range(moment(start), moment(end));
        },
        getDateRangeStartingNextDay: function(start, end){
            start = moment(start).add(1, 'day');
            return moment.range(moment(start), moment(end));
        },
        getPerPeriodAndTotalPrice: function(prices, dateRangeType, startDate, endDate, isPaxBased, quantity, paxConfig, isItemOnly){
            var dateRange = moment.range(startDate, endDate);
            var multiplier = null;
            var pricedPerTag = '';
            switch(dateRangeType){
                case 0:
                    // none
                    multiplier = 1;
                    pricedPerTag = 'Each';
                    if(isPaxBased) {
                        pricedPerTag = "Per Person";
                    }
                    break;
                case 1:
                    // daily
                    multiplier = dateRange.periods().period('days');
                    pricedPerTag = 'Per Day';
                    endDate = moment(endDate).add(1,'day');
                    dateRange = ExtraPricing.getDateRangeExclusive(startDate, endDate);
                    if(isPaxBased){
                        pricedPerTag = "Person / Day";
                    }
                    break;
                case 2:
                    // nightly
                    multiplier = dateRange.periods().period('nights');
                    pricedPerTag = 'Per Night';
                    if(isPaxBased){
                        pricedPerTag = "Person / Night";
                    }
                    break;
                case 3:
                    // weekly
                    multiplier = dateRange.periods().period('weeks');
                    pricedPerTag = 'Per Week';
                    break;
                case 4:
                    // monthly
                    multiplier = dateRange.periods().period('months');
                    pricedPerTag = 'Per Month';
                    break;
                case 5:
                    // daily inclusive
                    multiplier = dateRange.periods().period('days');
                    pricedPerTag = 'Per Day';
                    if(isPaxBased){
                        pricedPerTag = 'Person / Day';
                        dateRange = ExtraPricing.getDateRangeInclusive(startDate, endDate);
                    }
                    break;
            }

            var total = null;
            var pricePerPeriod = null;

            // loop through the pricing day by day.....

            var total = 0;
            var count = 0;
            var priceFrom = 0;
            var lastNightsTotal = 0;

            dateRange.by('days', function(moment){
                var formattedDate = moment.format('YYYY-MM-DD');
                total += prices[formattedDate];
                lastNightsTotal = prices[formattedDate];
                if(count === 0){
                    priceFrom = prices[formattedDate];
                }
                if(count > 0 && (pricedPerTag === 'Each' || pricedPerTag === 'Per Person')){
                    total = prices[formattedDate];
                }
                count++;
            });

            if(typeof priceFrom === 'undefined' || priceFrom === null){
                for(var price in prices){
                    if(prices.hasOwnProperty(price)){
                        priceFrom = prices[price];
                    }
                }
            }

            // remove last night for nightly extras
            if(dateRangeType === 2){
                total -= lastNightsTotal;
            }

            // weekly
            if(dateRangeType === 3 || dateRangeType === 4){
                total = priceFrom * multiplier;
            }

            // check in case user has set from and to date as the same date
            if(count === 0){
                var starter = moment(startDate).format('YYYY-MM-DD');
                total += prices[starter];
                priceFrom = prices[starter];
            }

            if(isItemOnly){
                total = priceFrom;
            }

            // check the pax requirements - these should add up to the quantity if no quantity is set
            if(isPaxBased){
                if(!(typeof paxConfig === 'undefined')) {
                    if (!(typeof paxConfig.adults === 'undefined' || typeof paxConfig.children === 'undefined' || typeof paxConfig.infants === 'undefined')) {
                        quantity = paxConfig.adults + paxConfig.children + paxConfig.infants;
                    }
                }
            }

            // take into consideration quantity
            if(!(typeof quantity === 'undefined')){
                total *= parseInt(quantity);
            }

            var pricingOb = {
                priced: pricedPerTag,
                totalPrice: total,
                priceFrom: priceFrom
            };
            return pricingOb;
        },

        buildPaxConfiguration: function(adults, children, infants) {
            if(adults === undefined || _.isNaN(parseInt(adults, 10))) {
                adults = 0;
            }
            if(children === undefined || _.isNaN(parseInt(children, 10))) {
                children = 0;
            }
            if(infants === undefined || _.isNaN(parseInt(infants, 10))) {
                infants = 0;
            }
            return {
                adults: parseInt(adults, 10),
                children: parseInt(children, 10),
                infants: parseInt(infants, 10),
                // Add a method to the pax object to return a count
                count: function(excludeInfants, excludeChildren) {
                    return this.adults + (excludeChildren ? 0 : this.children) + (excludeInfants ? 0 : this.infants);
                }
            };
        }

    }
})();
